import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_conversation_event_RowClass} from "../../../../dbschema";

export class ConversationEventContainerModel extends BaseContainerModel{
  bl_alg_cc_conversation_event: bl_alg_cc_conversation_event_RowClass = new bl_alg_cc_conversation_event_RowClass();
}
